<template>
    <v-container fluid class="py-0 my-0">
        <v-row justify="center" class=" py-0 my-0">
            <v-col cols="12" class="py-0 my-0">
                <v-row>
                    <v-col cols="4" style="max-height: 52px">
                        <v-select outlined dense :disabled="!showYearFilter" :class="showYearFilter?'textfield-primary':'textfield-disabled'" :items="$store.getters.yearsInfo.yearsList"
                                  v-model="selectedYear" item-value="year" item-text="yearLabel" @change="getLibraryOrders"
                                  label="Ακαδημαϊκό Έτος"/>
                    </v-col>
                    <v-col cols="6" style="max-height: 52px" v-if="institutionAlert">
	                    <v-alert
		                    icon="mdi-bank" dense
		                    outlined shaped text color="primary"
	                    >{{institutionAlert}}</v-alert>
                    </v-col>
                    <v-col cols="8" style="max-height: 52px"></v-col>
                </v-row>

                <v-row cols="12">

                    <v-data-table :style="{width:'100%'}"
                                  :items="filteredItems"
                                  :headers="headers"
                                  :footer-props="{
                                        itemsPerPageOptions:[5,15,25,-1],
                                        'items-per-page-text':'Ανά γραμμή',
                                        'items-per-page-all-text': 'Όλα',
                                        prevIcon: 'mdi-arrow-left-bold',
                                        nextIcon: 'mdi-arrow-right-bold'
                                    }"
                                  :items-per-page="15">

	                    <template v-slot:body.prepend>
		                    <tr>

			                    <td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
				                    <v-autocomplete style="font-size: 12px" item-value="department " item-text="department" :items="departmentItems" v-model="departmentFilter" hide-details dense/>
			                    </td>
			                    <td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
				                    <v-text-field style="font-size: 12px" v-model="bookFilter" hide-details dense/>
			                    </td>
			                    <td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
				                    <v-text-field style="font-size: 12px" v-model="amountFilter" hide-details dense/>
			                    </td>
			                    <td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
				                    <v-text-field style="font-size: 12px" v-model="pricePerItemFilter" hide-details dense/>
			                    </td>
			                    <td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
				                    <v-autocomplete style="font-size: 12px" item-value="value" item-text="label" :items="statusFilterItems" v-model="statusFilter" hide-details dense/>
			                    </td>
			                    <td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
				                    <v-text-field style="font-size: 12px" v-model="dateFilter" hide-details dense/>
			                    </td>
			                    <td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
				                    <v-btn small color="primary" outlined @click="clearFilters"><v-icon>mdi-broom</v-icon></v-btn>
			                    </td>
		                    </tr>
	                    </template>

                        <template v-slot:item="{ item }">
                            <tr >

                                <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                    {{item.academicName}}
                                </td>

                                <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                    [{{item.bookId}}] {{item.bookTitle}}
                                </td>
                                <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                    {{item.amount}}
                                </td>
                                <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                    {{item.pricePerItem}}
                                </td>
                                <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                    {{returnStatusText(item.status)}}
                                </td>
                                <td style="height: 40px" class="text-center d-sm-table-cell d-flex">
                                    {{item.statusDateString}}
                                </td>
                                <td style="height: 40px" v-if="item.status === 'Approved'" class="text-center d-sm-table-cell d-flex">
                                    <v-tooltip  top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" @click="acceptOrder(item)" fab x-small color="secondary"><v-icon size="21" color="primary">mdi-clipboard-check</v-icon></v-btn>
                                        </template>
                                        <span >Αποδοχή Παραγγελίας</span>
                                    </v-tooltip>
                                </td>

                                <td style="height: 40px" v-if="item.status === 'Pending'" class="text-center d-sm-table-cell d-flex">
                                    <v-tooltip  top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" @click="getPublisherInfo(item)" fab x-small color="secondary"><v-icon size="21" color="primary">mdi-account</v-icon></v-btn>
                                        </template>
                                        <span >Στοιχεία Εκδότη</span>
                                    </v-tooltip>
                                    <v-tooltip  top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn class="mx-2" v-on="on" @click="copyToClipboard(item)" fab x-small color="secondary"><v-icon size="21" color="primary">mdi-barcode-scan</v-icon></v-btn>
                                        </template>
                                        <div style="background-color: #c49f79; border: 2px solid #2c3e50;color: #2c3e50;font-size: 32px;padding: 10px;"> {{ ' ΠΙΝ -> ' + item.pin}}</div>
                                    </v-tooltip>
                                    <v-tooltip  top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" @click="cancelOrder(item)" fab x-small color="secondary"><v-icon size="21" color="indianRed">mdi-close-outline</v-icon></v-btn>
                                        </template>
                                        <span >Ακύρωση Παραγγελίας</span>
                                    </v-tooltip>
                                </td>
                                <td style="height: 40px" v-if="item.status === 'Completed' || item.status === 'Expired'" class="text-center d-sm-table-cell d-flex">
                                    <v-tooltip  top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" @click="getPublisherInfo(item)" fab x-small color="secondary"><v-icon size="21" color="primary">mdi-account</v-icon></v-btn>
                                        </template>
                                        <span >Στοιχεία Εκδότη</span>
                                    </v-tooltip>
                                </td>
<!--                                <td style="height: 40px" class="text-center d-sm-table-cell d-flex">-->
<!--                                    <v-btn @click="acceptOrder(item)" v-if="item.status === 'Approved'"  small outlined rounded color="secondary"> Αποδοχή Παραγγελίας </v-btn>-->
<!--                                    <v-btn @click="cancelReturnToLibrary(item, false)" v-else  small outlined rounded color="indianRed"> Ακύρωση Επιστροφής </v-btn>-->
<!--                                </td>-->
                            </tr>
                        </template>
                    </v-data-table>

                </v-row>
            </v-col>
        </v-row>
        <ConfirmDialogue ref="confirmDialog"/>
        <PublisherInfoDialog :publisher="publisherInfo"/>
        <v-snackbar @close="showSnackbar=false" transition="fab-transition" outlined text
                    color="#C49F79"
                    dark timeout="3000" v-model="showSnackbar" style="border: 6px solid #C49F79">

            <v-row>
                <v-col cols="1" style="min-height: 80px">
                    <v-icon large color="#C49F79"
                            style="margin: 0; position: absolute; top: 50%; transform: translateY(-50%);">
                        verified
                    </v-icon>
                </v-col>

                <v-col cols="11">
                    <p style="color: #C49F79;font-size: 17px;text-align: center;margin: auto;padding-top: 10px">
                        Αντιγράφηκε
                    </p>
                </v-col>
            </v-row>

        </v-snackbar>
    </v-container>
</template>

<script>
	import requests from "../requests";
	import ConfirmDialogue from "./ConfirmDialog";
	import PublisherInfoDialog from "./PublisherInfoDialog";

	export default {
		name: "LibraryOrders",
		components: {PublisherInfoDialog, ConfirmDialogue},
		data: () => ({
			showSnackbar:false,
			departmentFilter:'',
			bookFilter:'',
			statusFilter:'',
			statusFilterItems:[
				{value:'NotApproved', label:'Μη εγκεκριμένη'},
				{value:'Approved', label:'Εγκεκριμένη'},
				{value:'Pending', label:'Προετοιμασία για αποστολή'},
				{value:'Completed', label:'Ολοκληρωμένη'},
			],
			dateFilter:'',
			deliveryAmountFilter:'',
			pricePerItemFilter:'',
			amountFilter:'',
			institutionItems:[],
			libraryItems:[],
			departmentItems:[],
	        selectedYear:'',
            publisherInfo:{},
	        showYearFilter:true,
	        orders:[],
	        headers: [
		        { text: 'Τμήμα', value: 'academicName', align: 'center', sortable: true, width: '35%'},
		        { text: 'Βιβλίο', value: 'bookId', align: 'center', sortable: true, width: '30%'},
		        { text: 'Τεμάχια', value: 'amount', align: 'center', sortable: true, width: '2%'},
		        { text: 'Τιμή Τεμάχιου', value: 'pricePerItem', align: 'center', sortable: true, width: '3%'},
		        { text: 'Κατάσταση', value: 'status', align: 'center', sortable: true, width: '10%'},
		        { text: 'Ημερομηνία', value: 'statusDate', align: 'center', sortable: true, width: '5%'},
		        { text: 'Ενέργειες', value: 'amount', align: 'center', sortable: true, width: '15%'},
	        ],
			institutionAlert:'',
		}),

		computed: {
			filteredItems() {
				return this.orders.filter(item => {
					let departmentFilterMatch = false;
					let bookFilterMatch = false;
					let statusFilterMatch = false;
					let dateFilterMatch = false;
					let pricePerItemFilterMatch = false;
					let amountFilterMatch = false;

					if (this.departmentFilter === '') {
						departmentFilterMatch = true;
					} else {
						if (this.departmentFilter === item.academicName) {
							departmentFilterMatch = true;
						}
					}

					if (this.bookFilter === '') {
						bookFilterMatch = true;
					} else {
						if(isNaN(this.bookFilter)){
							console.log('entered');
							if (item.bookTitle.toString().toUpperCase().includes(this.bookFilter.toString().toUpperCase())) {
								bookFilterMatch = true;
							}
                        }else{
							if (item.bookId.toString().includes(this.bookFilter.toString())) {
								bookFilterMatch = true;
							}
                        }

					}


					if (this.amountFilter === '') {
						amountFilterMatch = true;
					} else {
						if (item.amount.toString().includes(this.amountFilter.toString())) {
							amountFilterMatch = true;
						}
					}


					if (this.pricePerItemFilter === '') {
						pricePerItemFilterMatch = true;
					} else {
						if (item.pricePerItem.toString().includes(this.pricePerItemFilter.toString())) {
							pricePerItemFilterMatch = true;
						}
					}

					if (this.statusFilter === '') {
						statusFilterMatch = true;
					} else {
						if (this.statusFilter === item.status) {
							statusFilterMatch = true;
						}
					}

					if (this.dateFilter === '') {
						dateFilterMatch = true;
					} else {
						if (item.statusDateString.toString().includes(this.dateFilter)) {
							dateFilterMatch = true;
						}
					}


					return departmentFilterMatch && bookFilterMatch && statusFilterMatch
                        && dateFilterMatch && amountFilterMatch && pricePerItemFilterMatch;
				});
			}
		},

        methods:{

	        clearFilters(){
		        this.departmentFilter = '';
		        this.bookFilter = '';
		        this.statusFilter = '';
                this.dateFilter = '';
                this.deliveryAmountFilter = '';
                this.pricePerItemFilter = '';
                this.amountFilter = '';
	        },

	        async copyToClipboard(item) {
		        try {
			        await navigator.clipboard.writeText(item.pin);
			        this.showSnackbar = true;
		        } catch (err) {
			        window.alert("Failed to copy text: ");
		        }
		        document.activeElement.blur();
	        },

	        getPublisherInfo(item){
		        document.activeElement.blur();
                requests.get('rest/library-orders/publisher-info/' + item.id, (resp) =>{
	                this.publisherInfo = JSON.parse(JSON.stringify(resp));
                	this.$store.commit('setPublisherInfoDialog', true);
                });
	        },

	        async acceptOrder(item){
		        document.activeElement.blur();
		        const ok = await this.$refs.confirmDialog.show({
			        message: 'Είστε σίγουρος/η ότι θέλετε να αποδεχθείτε την παραγγελία;'
		        });

		        if(ok){
			        this.$store.commit('setLoadingModal', true);
                    requests.post('rest/library-orders/accept', item.id, () =>{
                    	this.getLibraryOrders();
                    });

		        }
	        },

	        async cancelOrder(item){
		        document.activeElement.blur();
		        const ok = await this.$refs.confirmDialog.show({
			        message: 'Είστε σίγουρος/η ότι θέλετε να ακυρώσετε την παραγγελία;'
		        });

		        if(ok){
			        this.$store.commit('setLoadingModal', true);
                    requests.post('rest/library-orders/cancel', item.id, () =>{
                    	this.getLibraryOrders();
                    });

		        }
	        },

			returnStatusText(status){
				if(status === 'NotApproved') {
					return 'Μη εγκεκριμένη'
				}
				else if(status === 'Approved') {
					return 'Εγκεκριμένη'
				}
				else if(status === 'Pending') {
					return 'Προετοιμασία για αποστολή'
				}
				else if(status === 'Completed') {
					return 'Ολοκληρωμένη'
				}else if (status ==='Expired'){
					return 'Έχει λήξει';
				}else {
					return '--';
                }
            },

            getLibraryOrders(){
            	this.$store.commit('setLoadingModal', true);
                requests.get('rest/library-orders/' + this.selectedYear, (resp) =>{
	                this.orders = resp;
	                if(this.orders.length>0){
		                this.institutionAlert = this.orders[0].institutionName;
                    }
	                this.$store.commit('setLoadingModal', false);
                })
            },

            getDepartments(){
            	this.$store.commit('setLoadingModal', true);
                requests.get('rest/library-orders/departments', (resp) =>{
	                this.departmentItems = JSON.parse(JSON.stringify(resp));
                })
            },
        },

        created() {
			this.selectedYear = this.$store.getters.yearsInfo.activeYear;
			this.getLibraryOrders();
			this.getDepartments();
        }
	}
</script>

<style scoped>

</style>






